/**
 * Patch bus owned by CalendarStore — single write path for optimistic slot updates.
 */

export function createStorePatchBus() {
   const patches = [];
   const listeners = new Set();

   const notify = () => {
      for (const listener of listeners) {
         listener();
      }
   };

   return {
      subscribe(listener) {
         listeners.add(listener);
         return () => listeners.delete(listener);
      },
      getPatches() {
         return patches;
      },
      push(patch) {
         if (!patch || typeof patch !== "object") return;
         patches.push({ ...patch, seq: patches.length });
         notify();
      },
      replacePatches(nextPatches) {
         patches.length = 0;
         if (Array.isArray(nextPatches) && nextPatches.length) {
            for (const patch of nextPatches) {
               patches.push({ ...patch, seq: patches.length });
            }
         }
         notify();
      },
      clear() {
         if (!patches.length) return;
         patches.length = 0;
         notify();
      },
   };
}
